import React from "react";
import Library from "../Library";

const Icon = (props) => <Library name="fa-regular fa-address-card" {...props} />;

Icon.displayName = "Icon.AddressCard";
export default Icon;
